export default __webpack_public_path__ + "static/media/compensate-logo-white.2aae57e6.svg";